import layoutHeaderAside from '@/layout/header-aside'

//路由是否需要验证auth
const meta = { auth: true }
//路由name的前缀部分
const routePrefix = 'system-privilege-';
//重定向到
const redirectRouteName = routePrefix+'systemManage';

export default {
    path: '/systemPrivilege',
    name: 'systemPrivilege',
    meta,
    redirect: { name: 'system-privilege-menuManage' },
    component: layoutHeaderAside,
    children: (pre => [
        { 
            path: 'menuManage', 
            name: `${pre}menuManage`, 
            component: () => import('@/pages/systemPages/systemPrivilege/menuManage'), 
            meta: { 
                ...meta, 
                title: '菜单管理' 
            } 
        },
        { 
            path: 'organizationStructure', 
            name: `${pre}organizationStructure`, 
            component: () => import('@/pages/systemPages/systemPrivilege/organizationStructure'), 
            meta: { 
                ...meta, 
                title: '组织架构' 
            } 
        },
        { 
            path: 'roleManage', 
            name: `${pre}roleManage`, 
            component: () => import('@/pages/systemPages/systemPrivilege/roleManage'), 
            meta: { 
                ...meta, 
                title: '角色管理' 
            } 
        },
        { 
            path: 'userManage', 
            name: `${pre}userManage`, 
            component: () => import('@/pages/systemPages/systemPrivilege/userManage'), 
            meta: { 
                ...meta, 
                title: '用户管理' 
            } 
        }
    ])(routePrefix)
}
